import { render, staticRenderFns } from "./style-four.vue?vue&type=template&id=68d9d47a&scoped=true&"
import script from "./style-four.vue?vue&type=script&lang=js&"
export * from "./style-four.vue?vue&type=script&lang=js&"
import style0 from "./style-four.vue?vue&type=style&index=0&id=68d9d47a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d9d47a",
  null
  
)

export default component.exports